export const isWeChatBrowser = () => /MicroMessenger/i.test(navigator.userAgent)

export const readOpenIdFromCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)wechat_openid=([^;]*)/)
  if (!match?.[1]) return ''
  try {
    return decodeURIComponent(match[1].trim())
  } catch {
    return match[1].trim()
  }
}

export const readLastSubmissionId = () => {
  const match = document.cookie.match(/(?:^|;\s*)ylk_last_submission=(\d+)/)
  if (match?.[1]) return match[1]
  try {
    return localStorage.getItem('ylk_last_submission') || ''
  } catch {
    return ''
  }
}

export const getStoredOpenId = () => {
  try {
    return localStorage.getItem('wechatOpenId') || readOpenIdFromCookie() || ''
  } catch {
    return readOpenIdFromCookie()
  }
}

const BROWSE_MODE_KEY = 'ylk_browse_mode'

export const isBrowseMode = () => {
  try {
    return sessionStorage.getItem(BROWSE_MODE_KEY) === '1'
  } catch {
    return false
  }
}

export const enterBrowseMode = () => {
  try { sessionStorage.setItem(BROWSE_MODE_KEY, '1') } catch { /* ignore */ }
}

export const clearBrowseMode = () => {
  try { sessionStorage.removeItem(BROWSE_MODE_KEY) } catch { /* ignore */ }
}

const cookieSecure = () => (location.protocol === 'https:' ? '; Secure' : '')

export const persistOpenId = (openId, submissionId) => {
  if (!openId) return
  const id = openId.trim()
  try { localStorage.setItem('wechatOpenId', id) } catch { /* ignore */ }
  document.cookie = `wechat_openid=${encodeURIComponent(id)}; path=/; max-age=2592000; SameSite=Lax${cookieSecure()}`
  if (submissionId) {
    const sid = String(submissionId)
    try { localStorage.setItem('ylk_last_submission', sid) } catch { /* ignore */ }
    document.cookie = `ylk_last_submission=${sid}; path=/; max-age=2592000; SameSite=Lax${cookieSecure()}`
  }
}

export const getWeChatOpenId = () => {
  try {
    return localStorage.getItem('wechatOpenId') || ''
  } catch {
    return ''
  }
}

export const saveWeChatAuthFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const openid = urlParams.get('openid')
  const token = urlParams.get('token')
  const userId = urlParams.get('userId')

  if (openid) {
    persistOpenId(openid)
    clearBrowseMode()
    if (token) localStorage.setItem('token', token)
    if (userId) localStorage.setItem('userId', userId)

    const cleanUrl = window.location.pathname + window.location.hash
    window.history.replaceState({}, document.title, cleanUrl)
    return true
  }
  return false
}

export const ensureWeChatAuth = () => {
  if (saveWeChatAuthFromUrl())
    return true

  return !!getWeChatOpenId()
}

export const requireWeChatOpenId = () => {
  if (saveWeChatAuthFromUrl())
    return getWeChatOpenId()

  const fromCookie = document.cookie.match(/(?:^|;\s*)wechat_openid=([^;]*)/)
  if (fromCookie?.[1]) {
    try {
      const id = decodeURIComponent(fromCookie[1].trim())
      if (id) {
        persistOpenId(id)
        return id
      }
    } catch { /* ignore */ }
  }

  return getWeChatOpenId()
}
